import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Paper,
} from "@mui/material";
import EditOutlinedIcon from "../../../../../assets/icons/edit-outlined-icon.svg";
import DeleteIcon from "../../../../../assets/icons/delete-outlined-red-icon.svg";
import "./service-list-table.scss";

export interface ListHeader {
  key: string;
  label: string;
  align?: "left" | "center" | "right";
}

export interface ListRow {
  id: string | number;
  status?: string;
  [key: string]: any;
}

interface CommonListMUIProps {
  headers: ListHeader[];
  data: any[];
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  isReadOnly?: boolean;
}

const CommonListMUI: React.FC<CommonListMUIProps> = ({
  headers,
  data,
  onEdit,
  onDelete,
  isReadOnly,
}) => {
  return (
    <TableContainer component={Paper} className="common-mui-table">
      <Table sx={{ tableLayout: "fixed", width: "100%" }}>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <>
                {!(isReadOnly && header.key === "actions") &&  <TableCell
                  key={header.key}
                  align={header.align || "left"}
                  className="table-header-cell"
                  sx={{ width: `${120 / headers.length}%` }}
                >
                  {header.label}
                </TableCell>
              }</>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id} className="table-body-row">
              {headers.map((header) => {
                if (header.key === "actions") {
                  return (
                    <TableCell key={header.key} align="right">
                      {onEdit && (
                        <IconButton onClick={() => onEdit(row)} size="small">
                          <img src={EditOutlinedIcon} alt="edit" />
                        </IconButton>
                      )}
                      {onDelete && (
                        <IconButton
                          onClick={() => onDelete(row)}
                          size="small"
                          color="error"
                        >
                          <img src={DeleteIcon} alt="delete" />
                        </IconButton>
                      )}
                    </TableCell>
                  );
                }

                if (header.key === "status") {
                  return (
                    <TableCell key={header.key}>
                      <Chip
                        label={(row.status === "active" || row.status === true) ? 'Active' : 'Inactive'}
                        size="small"
                        className={`status-chip ${(row.status === "active" || row.status === true) ? 'active-chip' : 'inactive-chip'}`}
                      />
                    </TableCell>
                  );
                }
                if (header.key === "price") {
                  return (
                    <TableCell key={header.key} title={`$${row?.minPrice} - $${row?.maxPrice}`}>
                      ${row?.minPrice} - ${row?.maxPrice}
                    </TableCell>
                  );
                }
                return (
                  <TableCell key={header.key} title={header?.key === "name" ? row[header.key] : ""
                  }>{row[header.key]}</TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CommonListMUI;
